import { RepaymentMethods } from 'share/enums/payment'
import { ApplicationProgramCode } from 'share/types'
import type { LoanPurposes } from 'share/types/api/main'

export const getLoanPurposeText = (purpose: LoanPurposes | undefined) => {
  switch (purpose) {
    case 'INVESTMENTS':
      return 'loan.investments'
    case 'REPLENISHMENT':
      return 'loan.replenishment'
    default:
      return ''
  }
}

export const getProgramName = (program: ApplicationProgramCode | undefined | null) => {
  switch (program) {
    case 'DAMU':
      return 'programs.damu'
    case 'OWN_PROGRAM':
      return 'programs.own-program'
    default:
      return ''
  }
}

export const getRepaymentMethodName = (method: RepaymentMethods | undefined | null) => {
  switch (method) {
    case RepaymentMethods.ANNUITY:
      return 'repayment-methods.annuity'
    case RepaymentMethods.EQUAL_INSTALMENTS:
      return 'repayment-methods.equal-instalments'
    default:
      return ''
  }
}
